import { Injectable, inject } from '@angular/core';

import { WINDOW } from '@frontend/vanilla/core';

interface SiftData {
    configParams?: {
        siftJSBeaconKey?: string;
    };
    userInfo?: {
        singleAccountInfo?: {
            masterAccount?: string;
        };
        userId?: string;
    };
    clientInfo?: {
        sessionKey?: string;
    };
}

@Injectable({
    providedIn: 'root',
})
export class SiftDataService {
    private readonly window = inject(WINDOW);

    pushSiftData(data: SiftData) {
        const userId = data?.userInfo?.singleAccountInfo?.masterAccount ?? data?.userInfo?.userId;
        const sessionKey = data?.clientInfo?.sessionKey;
        const siftAccountID = data?.configParams?.siftJSBeaconKey;
        this.window['_sift'] = this.window['_sift'] || [];
        this.window['_sift']?.push(['_setAccount', siftAccountID], ['_setUserId', userId], ['_setSessionId', sessionKey], ['_trackPageview']);
    }
}
